import React, { useState, useEffect } from 'react';
import api from '../api';

const Aggregation = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const load = () => {
    setLoading(true);
    api.get('/aggregations/')
      .then(res => setRows(Array.isArray(res.data) ? res.data : res.data.results || []))
      .catch(() => setError('Failed to load aggregations'))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const runAggregate = async () => {
    setBusy(true);
    setError('');
    try {
      await api.post('/aggregations/aggregate/');
      load();
    } catch (err) {
      setError(err.response?.data?.error || 'Aggregate failed');
    } finally {
      setBusy(false);
    }
  };

  const distribute = async (id) => {
    setBusy(true);
    setError('');
    try {
      await api.post(`/aggregations/${id}/distribute/`);
      load();
    } catch (err) {
      setError(err.response?.data?.error || 'Distribute failed');
    } finally {
      setBusy(false);
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div>
      <div className="flex-between">
        <h2>Aggregation</h2>
        <button className="btn btn-primary" onClick={runAggregate} disabled={busy}>Run Aggregate</button>
      </div>
      {error && <div className="error">{error}</div>}
      <table className="table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Date</th>
            <th>Members</th>
            <th>Total Amount</th>
            <th>Discount</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {rows.map(r => (
            <tr key={r.id}>
              <td>{r.id}</td>
              <td>{r.date}</td>
              <td>{r.member_count}</td>
              <td>{Number(r.total_amount).toLocaleString()}</td>
              <td>{Number(r.discount_amount).toLocaleString()}</td>
              <td><span className={`badge ${r.status}`}>{r.status}</span></td>
              <td>
                {r.status !== 'distributed' && (
                  <button className="btn btn-success" onClick={() => distribute(r.id)} disabled={busy}>
                    Distribute
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Aggregation;
